import React, { Component } from 'react';
import { NormalizedSeries, IChartGroup } from 'types';
import { ICON_ADD } from 'icons';
import styles from './chart.scss';
import { DropTarget, DropTargetSpec } from 'react-dnd';
import { SlideLeft } from 'ui/transition';
import { CHART_TARGET_TYPE } from './utils';

interface ChartAddGroupBtnProps {
  groupIndex: number;
  groups: IChartGroup[];
  series?: NormalizedSeries[];
  newGroup: boolean;
  onGroupUpdate: (groups: string[][]) => void;
}

const dragTarget: DropTargetSpec<ChartAddGroupBtnProps> = {
  canDrop(props, monitor) {
    const { id } = monitor.getItem();
    return !props.series || props.series.findIndex(s => s.id === id) === -1;
  },
  drop(props, monitor) {
    const { id: seriesId } = monitor.getItem();

    const groups = props.groups.slice();
    let moveSeries;
    for (let i = 0; i < groups.length; i++) {
      const index = groups[i].series.indexOf(seriesId);
      if (index !== -1) {
        const group = groups[i];
        moveSeries = group.series[index];
        group.series = group.series.slice();
        group.series.splice(index, 1);
      }
    }
    if (moveSeries) {
      if (props.newGroup) {
        groups.splice(props.groupIndex + 1, 0, { series: [moveSeries] });
      } else {
        const newGroup = groups[props.groupIndex];
        newGroup.series = newGroup.series.concat(moveSeries);
      }

      props.onGroupUpdate(groups.filter(g => g.series.length));
    }
  }
};

@DropTarget(CHART_TARGET_TYPE, dragTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  canDrop: monitor.canDrop(),
  isOver: monitor.isOver()
}))
class ChartAddGroupBtn extends Component<ChartAddGroupBtnProps> {
  render() {
    const { connectDropTarget, className, canDrop, isOver, newGroup } = this.props;
    let cl = styles.addGroupBtn;

    if (isOver) cl += ' ' + styles.highlight;
    return connectDropTarget(
      <div className={className}>
        <SlideLeft in={canDrop} className={cl}>
          {ICON_ADD} {newGroup ? 'Create new chart group' : 'Add in group'}
        </SlideLeft>
      </div>
    );
  }
}

export default ChartAddGroupBtn;
